'use client';

import { useEffect } from 'react';

export const ReactGrab = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      Promise.all([import('react-grab'), import('@react-grab/mcp/client')]).catch(e => {
        console.warn('Failed to load react-grab dev tools:', e);
      });
    }
  }, []);

  return null;
};
